import { useQuery } from '@tanstack/react-query';
import { getReviewsList } from '../api';
import type { ReviewFilters } from '../types';

export const REVIEWS_QUERY_KEY = 'reviews';

interface UseReviewsOptions {
  filters?: ReviewFilters;
  enabled?: boolean;
}

export function useReviews({
  filters, enabled = true 
}: UseReviewsOptions = {}) {
  return useQuery({
    queryKey: [REVIEWS_QUERY_KEY, filters],
    queryFn: () => getReviewsList(filters),
    enabled,
    staleTime: 30_000,
    gcTime: 5 * 60 * 1000,
  });
}
